import { createSelector } from 'reselect';

const selectPaymentMethods = (state: any) => state.paymentMethods;


export const selectPaymentMethodsCurrentItem = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.current);

export const selectPaymentMethodsListItems = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.list);

export const selectPaymentMethodsItemById = (itemId: any) =>
    createSelector(selectPaymentMethodsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPaymentMethodsQueryItems = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.query);

export const selectPaymentMethodsCreatedItem = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.create);

export const selectPaymentMethodsUpdatedItem = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.update);

export const selectPaymentMethodsReadItem = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.read);

export const selectPaymentMethodsDeletedItem = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.delete);

export const selectPaymentMethodsSearchedItems = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.search);

export const selectPaymentMethodsItemsCount = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.count);

export const selectPaymentMethodsItemsFilter = createSelector([selectPaymentMethods], (paymentMethods) => paymentMethods.filter);